// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"6574f9ef","125":"cc0b81ea","184":"8b5a7209","216":"0126c123","279":"56f40539","291":"db05cb95","315":"64c1a6ca","509":"561eab1f","515":"b4591916","520":"4b8a21c1","522":"39f1c9c0","603":"3ba7c45a","811":"fd9f48e6","956":"835ec5ab"}[chunkId] + ".chunk.js";
};